// removed by extract-text-webpack-plugin
module.exports = {"post":"_1o-jY-vHJ7hiDiE_k2YlB7_0","header":"_37AZ-z933Rur9ihDYRDgVC_0","title":"kN8K61i5_rTIWbcTJ73Au_0","body":"_2mkRwUMKTgAaC6tgfb7FBn_0","meta":"_2WO1_CNLqda03HEoUCNnHZ_0","content":"pWi0GIr0Dw6vyPeZenw7O_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-8ff26ee0!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Post.vue
// module id = 63
// module chunks = 2